import { useCircularTimerProps } from '@/common/components/camera/types/hooksTypes';
import { useRef, useState } from 'react';

const useCircularTimer = ({ totalTime, onTimerEnd }: useCircularTimerProps) => {
  const [time, setTime] = useState(totalTime);
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const captureRef = useRef<boolean>(false);

  const startTimer = () => {
    if (captureRef.current) return;
    captureRef.current = true;
    timerRef.current = setInterval(() => {
      setTime((prev) => {
        if (prev <= 0) {
          clearInterval(timerRef.current!);
          captureRef.current = false;
          resetTimer();
          onTimerEnd();
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };
  const resetTimer = () => {
    stopTimer();
    setTime(totalTime);
  };

  const stopTimer = () => {
    captureRef.current = false;
    clearInterval(timerRef.current!);
  };
  const fraction = time / totalTime;

  return { time, startTimer, resetTimer, stopTimer, fraction, timerRef };
};
export default useCircularTimer;
